export const FETCH_ONGOING_CONTEST_REQUEST = 'FETCH_ONGOING_CONTEST_REQUEST';
export const FETCH_ONGOING_CONTEST_SUCCESS = 'FETCH_ONGOING_CONTEST_SUCCESS';
export const FETCH_ONGOING_CONTEST_FAILURE = 'FETCH_ONGOING_CONTEST_FAILURE';

export const FETCH_CONTEST_DETAIL_REQUEST = 'FETCH_CONTEST_DETAIL_REQUEST';
export const FETCH_CONTEST_DETAIL_SUCCESS = 'FETCH_CONTEST_DETAIL_SUCCESS';
export const FETCH_CONTEST_DETAIL_FAILURE = 'FETCH_CONTEST_DETAIL_FAILURE';